import * as React from 'react';
import { QuestionProps, Question } from '../../interfaces';

export class TextQuestion extends React.Component<QuestionProps> implements Question {
    public render() {
        return (
            <div className="text-question-wrapper question">
                <div className="statement-number">Statement #{this.props.questionNumber}</div>
                <h2>{this.props.question.text}</h2>
                <hr />
                <div className={`options ${this.props.question.visualStyle}`}>
                    {this.props.question.questionType === 'text' && <input value={this.props.question.value} type="text" onChange={(e) => this.setText(e)} />}
                    {this.props.question.questionType === 'freeText' && <textarea onChange={(e) => this.setText(e)}>{this.props.question.value}</textarea>}
                </div>
            </div>);
    }

    setText(e: any) {
        this.props.question.value = e.target.value;
        this.forceUpdate();
    }
}


// WEBPACK FOOTER //
// ./src/components/assessment/TextQuestion.tsx